import { RENDER_ORDER } from "@graphic/constants";
import { useTimeControlStore, useTimeStore } from "@graphic/stores";
import { useFrame, useThree } from "@react-three/fiber";

import { useEffect } from "react";

const TimeSetup = () => {
  const { play, speed, direction } = useTimeControlStore();
  const { time, setTime } = useTimeStore();
  const invalidate = useThree(state => state.invalidate);

  // detect timer state change
  useEffect(() => {
    invalidate();
  }, [time, play, speed, direction]);

  useFrame(({ invalidate }, delta) => {
    const { play, speed, direction } = useTimeControlStore.getState();
    if (!play) return;

    if (delta > 0.1) return;

    const dir = direction === "forward" ? 1 : -1;
    const time = useTimeStore.getState().time;
    const newTime = time.add(delta * speed * dir, "second");

    setTime(newTime);
    invalidate();
  }, RENDER_ORDER.TIME);

  return null;
};
export default TimeSetup;
